const protocolSuffix = ENVIRONMENT === 'production' ? '' : `-${ENVIRONMENT}`;
export const DESKTOP_PROTOCOL = `paradigm${protocolSuffix}`;
export const PWA_PROMPT_SOFT_KEY = 'pwa-prompt-soft-dismiss';
export const PWA_PROMPT_PERMANENT_KEY = 'pwa-prompt-permanent-dismiss';

export const FEATURE_UM_UI_OB_V1_API = 'feature_um_ui_ob_v1_api';
export const FEATURE_UM_RFQ_HIDDEN_LIMIT_ORDER =
  'feature_um_rfq_hidden_limit_order';
export const FEATURE_UM_MULTI_PRODUCT_RFQ = 'feature_um_multi_product_rfq';

// Nets the hedge (future/perp) leg into a hedged RFQ's mark, traded price
// and delta. Read by the API too (feature_um_hedge_net_mark): the two
// sides must flip together, because with it on the server serves net
// prices and the maker quotes net, converting back to the premium on
// submit. Off, every price the UI sends and reads is the option premium.
export const FEATURE_UM_HEDGE_NET_MARK = 'feature_um_hedge_net_mark';

// Remote recovery hatch: directive (carried in this flag's config) that lets ops
// force targeted/old-version clients to clear caches and hard-reload onto the
// current deployed build. See ui/desktop/src/cacheReset.ts.
export const FEATURE_WEB_CACHE_RESET = 'feature_web_cache_reset';

export const ELECTRON_DEPRECATION_PROMPT_KEY =
  'electron-deprecation-prompt-dismiss';
